import React, {Component} from 'react';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import { alert } from 'util/alert';
import ImageCropper from 'template/Modals/ImageCropper';
import createContent from 'controllers/poster/createContent'
import uploadPicture from 'controllers/poster/uploadPicture'
import Loading from 'components/UI/Loading'
import {fetchPosterDetail} from './ducks'

// import { Editor } from 'react-draft-wysiwyg';
// import { EditorState, convertToRaw, ContentState } from 'draft-js';

import Editor from 'vendor/react-medium-editor';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const ACCEPT_MIME = 'image/png,image/jpeg';
const MAX_SIZE = 5 * 1000 * 1000;
const MIN_SIZE = 0;

import 'medium-editor/dist/css/medium-editor.css';
import 'medium-editor/dist/css/themes/default.css'

import locale from './locale';


export const EDITOR_BUTTONS = [
  'removeFormat',
  'bold',
  'italic',
  'justifyCenter',
  'justifyLeft',
  'h2',
  'h3',
  'orderedlist',
  'unorderedlist',
];

class EditItem extends Component{
  constructor(props){
    super(props)

    this.selectImage = this.selectImage.bind(this)
    this.renderEditor = this.renderEditor.bind(this)
    this.onTextChange = this.onTextChange.bind(this);
    this.removeSelf = this.removeSelf.bind(this);

    const {
      text,
      image_url,
      video_url,
      content_type,
    } = props.content;

    this.state = {
      creating: false,
      text,
      image_url,
      video_url,
      content_type,
    }
  }

  selectImage(accepted, rejected){

    if (rejected.length > 0) {
      alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
      return;
    } else if (accepted.length === 0) {
      alert.warning('', __('No Image Selected'));
      return;
    }

    let {
      onImageChange,
      index,
      location,
      params,
      removeItemWithoutConfirm
    } = this.props

    const posterId = params.posterId;

    ImageCropper({
      file: accepted[0],
      removeItem: removeItemWithoutConfirm
    })
    .then(({ file, imageUrl, dataUrl })=>{
      let {onImageChange, index, addItem, content} = this.props

      if (file) {
        this.setState({
          creating: true,
        });

        uploadPicture(posterId, file)
          .then((res) => {
            addItem(index, {
              content_type: 'picture',
              image_url: res.save_to,
            });

            // STEP 3. CREATING COMPLETE
            this.setState({
              creating: false,
            });
          });
      }

    })
    .catch((err)=>{

    });

  }

  renderTrash(){
    let {emptyContentsCount, index, removeItem, posterDetail, contentId} = this.props;
    let {contentList} = posterDetail;
    let {content_type} = this.props.content;

    if(emptyContentsCount > 1 || contentList.length > 0 ){
      return(
        <i className='fa icon-trash edit-item-trash' onClick={() => {
          this.removeSelf();
        }}></i>
      )
    }

  }

  removeSelf() {
    let {index, contentId, content, removeItem} = this.props;
    let {content_type} = content;
    removeItem(index, contentId, content_type);
  }

  removeSelfWithoutConfirm() {
    let {index, contentId, content, removeItemWithoutConfirm} = this.props;
    let {content_type} = content;
    removeItemWithoutConfirm(index, contentId);
  }

  onTextChange(text, medium, e) {
    let {
      index,
      onContentChange,
      contentId,
      removeItem,
    } = this.props
    let {content_type} = this.props.content;

    if ((e.inputType === 'deleteContentBackward' && text.length === 0) || (e.inputType === 'input' && text == '<p><br></p>')) {
      removeItem(index, contentId, content_type);
      return;
    }

    onContentChange(index, {
      text,
      id: contentId,
    });
  };

  renderEditor(){
    let {index, removeItem, emptyContentsCount, posterDetail, contentId, params, dispatch, onEditEnd, onEditStart, content} = this.props

    const {text, image_url, video_url, content_type, textView} = content;

    let {creating} = this.state;
    let {posterId} = params

    if (creating == true){
      return(
        <div className='creating-section text-center'>
          <Loading />
        </div>
      )
    }

    if(content_type == 'text'){
      const { editorState , textView} = this.state;
      return (
        <Editor
          ref={(r) => {
            if(r){
              this.textEditorRef = r
            }
          }}
          onChange={this.onTextChange}
          text={text}
          options={{
            placeholder: {
              text: __('Enter Your Text', locale),
              hideOnClick: false,
            },
            toolbar: {
              buttons: EDITOR_BUTTONS,
            },
          }}
        />
      )
    } else if (content_type == 'picture'){
      return (
        <div className='section'>
          <div className='image'>
            <img width='100%' src={image_url} />
          </div>
          {this.renderTrash()}
        </div>
      )
    }
  }

  render() {
    const {
      textView,
    } = this.state;

    const {
      id,
      content_type,
    } = this.props.content;

    return(
      <div data-qa-json={JSON.stringify(this.props.content)} className={classnames('edit-item', { 'do-not-drag-my-parent': textView !== true && content_type !== 'picture' })}>
        { content_type === 'text' &&
          <div className='add-item'>
            <Dropzone
              accept={ACCEPT_MIME}
              multiple={false}
              className='zone'
              maxSize={MAX_SIZE}
              minSize={MIN_SIZE}
              onDrop={this.selectImage}
              children={(
                <div className='add-item-btn'>
                  <i className='fa icon-picture'></i>
                  <i className='fa icon-plus'></i>
                </div>
              )}
            />
          </div> }
        {this.renderEditor()}
      </div>
    );
  }
}


export default EditItem



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/EditItem.js